import React from "react";
import localeText from "../../../locale";

const ConfimeaFooter = () => {
  return (
    <footer className="confimea-footer">
      <div className="confimea-container">
        <div className="confimea-footer-grid">
          <div className="confimea-footer-col">
            <h4>{localeText("footerPartnership")}</h4>
            <ul>
              <li>
                <a href="#benefits">{localeText("footerLink1")}</a>
              </li>
              <li>
                <a href="#how-it-works">{localeText("footerLink2")}</a>
              </li>
              <li>
                <a href="#faq">{localeText("footerLink3")}</a>
              </li>
            </ul>
          </div>

          <div className="confimea-footer-col">
            <h4>{localeText("footerQuickLinks")}</h4>
            <ul>
              <li>
                <a href="#form">{localeText("footerLink5")}</a>
              </li>
              <li>
                <a href="#contact">{localeText("footerLink6")}</a>
              </li>
            </ul>
          </div>

          <div className="confimea-footer-col confimea-footer-contact">
            <h4>{localeText("footerContacts")}</h4>
            <p>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                width="16"
                height="16"
              >
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              <a href="https://wa.me/+3905411837162" target="_blank" rel="noopener noreferrer">
                +39 0541 183 7162
              </a>
            </p>
            <p>
              <i className="pi pi-envelope" style={{ color: "#d1d5db", fontSize: "1rem" }}></i>
              <a href="mailto:segreteria@confimea.com" target="_blank" rel="noopener noreferrer">
                segreteria@confimea.com
              </a>
            </p>
            <p>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                width="16"
                height="16"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              Via Cesare Beccaria, 16 – 00196 Roma (RM).
            </p>
          </div>
        </div>

        <div className="confimea-footer-bottom">
          <p className="confimea-footer-copy">
            © {/* {new Date().getFullYear()} {localeText("footerCopyright")} */}Copyright 2022
            Confederazione italiana dell’impresa – CF/P.I. 97480640156 – Codice Univoco SDI: M5UXCR1
          </p>
          <div className="confimea-footer-social">
            <a
              href="https://www.linkedin.com/company/extraconomy/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                <rect x="2" y="9" width="4" height="12" />
                <circle cx="4" cy="4" r="2" />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/people/Extraconomy/61566025845885/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/extraconomy_official?igsh=bnQ3YmZ6MDVpZHZz"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>
            <a
              href="https://www.tiktok.com/@extraconomy?_t=8q7VnsHEI9B&_r=1"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
              </svg>
            </a>
            <a
              href="https://x.com/extraconomy?t=epoCHWYeokYWEYL3E5MbbQ&s=08"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ConfimeaFooter;
